import Axios from '@/store/axios'
import * as Sentry from "@sentry/browser"
var Promise = require('bluebird')

  const initialState = () => ({
    is_logged_in: false
  });

  const state = initialState();
  const getters = {
  }
  const mutations = {
    SET_LOGIN_SUCCESSFUL : (state) => {
      state.is_logged_in = true;
    },
    RESET: (state) => {
      const newState = initialState();
      Object.keys(newState).forEach( key => {
        state[key] = newState[key]
      });
    }
  }
  const actions = {
    LOGIN : (context, credentials) => {
      return Promise.try( () => {
        return Axios.post(`users/login`, {
          username: credentials.email,
          password: credentials.password
        })
      }).catch( (error) => {
        console.log(error)
        if(error.response.status == '401')
          throw new Error('wrong username or password')
        else
          throw new Error('unexpected server error')
      }).then( (login_response) => {
        context.commit('SET_LOGIN_SUCCESSFUL');
        Sentry.setUser({ "id": login_response.data.user.id }); // track users by ID in Sentry, otherwise it just gives us the rProxy IP
        return login_response.data.client
      }).then( (user_object) => {
        // go ahead and commit our account information to the store
        context.commit('user/SET_ACCOUNT_INFORMATION', user_object, { root: true })
        return
      })
    },
    LOGOUT : (context) => {
      return Promise.try( () => {
        if(context.rootState.user.id)
          return Axios.get(`users/${context.rootState.user.id}/logout`)
        else
          return
      }).then( (logout_response) => {
        // { root: true } allows us to dispatch a mutation in the root store from a namespaced module
        // it HAS to be the third argument here, so null is passed as an argument to the mutation since it takes no argument
        // this mutation sets is_logged_in to its default state false
        return context.dispatch('RESET', null, { root: true })
      })
    },
    REGISTER : (context, new_user) => {
      return Promise.try( () => {
        return Axios.post('users', {
          first_name: new_user.first_name,
          last_name: new_user.last_name,
          email: new_user.email,
          new_password: new_user.password,
          confirm_password: new_user.password
        })
      }).catch( (error) => {
        console.log(error)
        if(error.response.status == '400')
          throw new Error('passwords do not match')
        else if(error.response.status == '409')
          throw new Error('email already exists')
        else if(error.response.status == '500')
          throw new Error('unexpected error')
      })
    }
  }

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
